// src/components/ProjectsCarousel.jsx
import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { EffectCoverflow, Autoplay, Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";

const ProjectsCarousel = ({ projects = [] }) => {
  return (
    <div className="container py-5 position-relative">

      {/* Background Glow */}
      <div className="carousel-bg-glow"></div>

      <div className="text-center mb-4">
        <h2 className="text-secondary fw-light mb-2">Our Projects</h2>

        <h1
          className="fw-bolder"
          style={{
            fontSize: "clamp(2rem, 5vw, 3rem)",
            backgroundImage: "linear-gradient(45deg, #3C467B, #132440)",
            WebkitBackgroundClip: "text",
            color: "transparent",
          }}
        >
          Proud to be part of Solution
        </h1>
      </div>

      <Swiper
        effect="coverflow"
        grabCursor
        centeredSlides
        slidesPerView="auto"
        loop
        spaceBetween={20}
        autoplay={{ delay: 2800, disableOnInteraction: false }}
        pagination={{ clickable: true }}
        coverflowEffect={{
          rotate: 18,
          stretch: 0,
          depth: 180,
          modifier: 1.4,
          slideShadows: false,
        }}
        modules={[EffectCoverflow, Autoplay, Pagination]}
        style={{ paddingBottom: "70px" }}
      >
        {projects.map((p, i) => (
          <SwiperSlide key={i} className="project-card-3d">
            <div className="card-inner">
              <div className="card-image-wrapper">
                <img src={p.imageSrc} alt={p.title} className="card-img" />
                <span className="card-badge">Featured</span>
              </div>

              <div className="card-content">
                <h3 className="card-title">{p.title}</h3>
                <p className="card-desc">{p.description}</p>

                <a
                  href={p.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="card-link"
                >
                  {p.linkText} →
                </a>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      {/* STYLES */}
      <style>{`
        /* Background Glow */
        .carousel-bg-glow {
          position: absolute;
          top: 50%;
          left: 50%;
          width: 900px;
          height: 900px;
          background: radial-gradient(circle, rgba(19,36,64,0.25), transparent 70%);
          transform: translate(-50%, -50%);
          z-index: -1;
          filter: blur(80px);
        }

        /* Responsive Card Sizing */
        .project-card-3d {
          width: clamp(260px, 70vw, 360px);
          height: clamp(380px, 75vw, 480px);
          border-radius: 22px;
          overflow: hidden;
          perspective: 1500px;
        }

        /* Card Inner */
        .card-inner {
          background: rgba(255,255,255,0.9);
          backdrop-filter: blur(16px);
          border-radius: 22px;
          height: 100%;
          box-shadow: 0 20px 45px rgba(0,0,0,0.18);
          border: 1px solid rgba(200,200,200,0.35);
          transition: transform 0.45s ease, box-shadow 0.45s ease;
        }

        .project-card-3d:hover .card-inner {
          transform: rotateX(10deg) rotateY(-8deg) scale(1.03);
          box-shadow: 0 30px 60px rgba(0,0,0,0.28);
        }

        /* Image */
        .card-image-wrapper {
          height: 50%;
          overflow: hidden;
          position: relative;
        }

        .card-img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.7s ease;
        }

        .project-card-3d:hover .card-img {
          transform: scale(1.12);
        }

        /* Featured badge */
        .card-badge {
          position: absolute;
          top: 15px;
          right: 15px;
          font-size: 0.7rem;
          padding: 6px 14px;
          border-radius: 50px;
          background: linear-gradient(45deg, #3C467B, #132440);
          color: white;
          box-shadow: 0 6px 18px rgba(0,0,0,0.18);
        }

        /* Content */
        .card-content {
          padding: 20px;
          height: 50%;
          display: flex;
          flex-direction: column;
        }

        .card-title {
          font-size: clamp(1rem, 3vw, 1.25rem);
          font-weight: 700;
          color: #132440;
        }

        .card-desc {
          color: #666;
          font-size: clamp(0.8rem, 2.5vw, 0.95rem);
          margin-top: 8px;
          flex-grow: 1;
        }

        .card-link {
          font-weight: bold;
          font-size: clamp(0.9rem, 3vw, 1rem);
          color: #132440;
          text-decoration: none;
        }
      `}</style>
    </div>
  );
};

export default ProjectsCarousel;
